import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MARQUEE_TEXT } from "../mock";

export default function Marquee() {
  const items = Array.from({ length: 6 }).map(() => MARQUEE_TEXT);
  return (
    <Link
      to="/for-sale"
      className="block bg-[#0a0a0a] text-[#f5a623] overflow-hidden border-y-4 border-[#f5a623]"
    >
      <div className="emc-marquee-track py-3.5">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="flex items-center gap-3 font-bold uppercase text-sm tracking-wider">
            {t} <ArrowRight className="w-4 h-4" />
          </span>
        ))}
      </div>
    </Link>
  );
}
